import { CheckPicker } from 'rsuite';
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 30%;
  min-width: 424px;
  padding-left: 54px;
  padding-right: 54px;
  box-shadow: 0 2px 12px 0 rgba(171, 185, 205, 0.4);
  background-color: #ffffff;
  padding-top: 29px;
  overflow-y: scroll;
`;

export const SidePanelItemWrapper = styled.div``;

export const SidePanelBodyWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  // tmp
  margin-bottom: 22px;
`;

export const Select = styled(CheckPicker)`
  width: 200px;

  .rs-picker-toggle {
    background: unset !important; /* !important: shortcut no rules for :foc :hov item:hov :act etc*/
  }

  .rs-picker-toggle-placeholder {
    color: #020b2c;
  }
`;

export const SelectLabel = styled.div`
  :before {
    content: 'Select Chart';
    color: #020b2c;
  }
`;

export const ItemWrapper = styled.div`
  margin-top: 27px;
  margin-bottom: 64px; /* assumes margins top and bottom will collapse, not add */
`;

export const ItemHeader = styled.div`
  height: 22px;
  line-height: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .item-header-icon {
    width: 20px;
    height: 20px;
  }
`;

export const ItemTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: #101938;
  margin-bottom: 22px;
`;

export const ItemContent = styled.div`
  margin-top: 20px;
`;
